<template>
  <div class="content">
    <!-- 상단 필터 영역: 날짜 + 3시간 버킷 + 단축 -->
    <card>
      <div class="row align-items-center g-2">
        <div class="col-3 mb-2">
          <ArtistSelect
            class="w-100"
            @memberChangeEvent="getArtistInfo"
            :show-members="false"
            :is-filter="true"
            :show-all-units="true"
            :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
          />
        </div>
        <div class="col-md-3">
          <el-date-picker
            v-model="filters.date"
            type="date"
            placeholder="날짜 선택"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="onDateChange"
            class="w-100"
          />
        </div>
        <div class="col-md-1 d-flex align-items-center gap-2">
          <base-button type="default" @click="onPrev">이전</base-button>
        </div>
        <div class="col-md-1 d-flex align-items-center gap-2">
          <base-button type="default" @click="onNext">다음</base-button>
        </div>
        <div class="col-md-1 d-flex align-items-center gap-2">
          <base-button type="default" @click="onLatest">최신</base-button>
        </div>
      </div>
    </card>

    <!-- 본문: 전체 콘텐츠 4열 카드 -->

    <div v-if="posts.length" class="row g-3">
      <div class="col-3" v-for="post in posts" :key="post.id || post.contentId">
        <div class="card h-100">
          <img v-if="post.imageFileId" :src="post.imageFileId | blipImageUrl" :alt="post.title" class="card-img-top" />
          <img v-else-if="post.imageUrl" :src="post.imageUrl" :alt="post.title" class="card-img-top" />
          <div class="card-body d-flex flex-column">
            <h5 class="card-title fs-6 mb-1">{{ post.title }}</h5>
            <p class="card-text text-muted small mb-2">{{ getSourceLabel(post) }} · {{ post.date }}</p>
            <p class="card-text flex-grow-1" v-if="post.description">{{ post.description }}</p>
            <div class="d-flex gap-2 mt-2">
              <base-button type="default" @click="openDetail(post)">상세</base-button>
              <base-button type="primary" @click="openComments(post)">댓글</base-button>
              <base-button type="danger" @click="deletePost(post)">삭제</base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="card">
      <div class="card-body text-center text-muted py-5">아티스트와 시간(6h)을 선택하면 콘텐츠가 표시됩니다.</div>
    </div>

    <!-- 댓글 팝업 -->
    <el-dialog :visible.sync="commentsVisible" width="720px" :append-to-body="true" title="댓글 목록">
      <div v-if="commentsLoading" class="text-center py-4">로딩 중...</div>
      <div v-else>
        <div v-if="!comments.length" class="text-center text-muted py-4">댓글이 없습니다.</div>
        <ul v-else class="list-group">
          <li v-for="c in comments" :key="c.id" class="list-group-item d-flex justify-content-between align-items-start gap-3">
            <div class="me-3">
              <a href="#" @click.prevent="openUser(c.userId)">{{ c.nickname || c.userId }}</a>
            </div>
            <div class="flex-grow-1">
              {{ c.comment }}
            </div>
            <div class="small text-muted mt-1">
              <span v-if="c.state !== 1">삭제됨 · </span>
              {{ new Date(c.regTime).toLocaleString() }}
            </div>
            <div class="ms-3">
              <base-button size="sm" :type="c.state === 1 ? 'danger' : 'default'" @click="toggleComment(c)">
                {{ c.state === 1 ? "삭제" : "복구" }}
              </base-button>
            </div>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import Card from "@/components/Cards/Card.vue";

export default {
  name: "ViewerRank",
  components: { Card, ArtistSelect },
  data() {
    return {
      // 상단 필터
      filters: {
        unitId: null,
        date: null, // 'YYYY-MM-DD'
        // time: null, // yyyymmddHH (number) -- handled below
      },
      // buckets: [], // [{ time: 2025091700, label: '00:00' }, ...]

      // 우측 카드들
      posts: [], // { id, title, link, imageUrl, source, date, description }
      commentsVisible: false,
      commentsLoading: false,
      comments: [], // [{ id, contentId, unitId, userId, comment, state (1=active,0=deleted), regTime, modTime }]
      commentsForContentId: null,
    };
  },
  watch: {
    "$route.query"(q) {
      if (q.time && Number(q.time) !== this.filters.time) {
        this.applyTime(Number(q.time));
      }
    },
  },
  created() {
    const { time, unitId, contentId } = this.$route.query;

    if (time) {
      this.applyTime(Number(time));
    } else {
      // 파라미터 없으면 최신으로 자동 세팅
      this.onLatest();
    }

    if (unitId) this.filters.unitId = Number(unitId); // 첫 진입시에만 적용

    if (contentId) {
      this.$nextTick(() => this.openComments({ id: Number(contentId) }));
      const url = new URL(window.location.href);
      url.searchParams.delete("contentId");
      window.history.replaceState({}, "", url);
    }
  },
  methods: {
    toDateFromTimeNum(tNum) {
      const s = String(tNum);
      const y = Number(s.slice(0, 4));
      const m = Number(s.slice(4, 6)) - 1;
      const d = Number(s.slice(6, 8));
      const h = Number(s.slice(8, 10));
      return new Date(y, m, d, h, 0, 0, 0);
    },
    timeNumFromDate(dt) {
      const y = String(dt.getFullYear());
      const m = String(dt.getMonth() + 1).padStart(2, "0");
      const d = String(dt.getDate()).padStart(2, "0");
      const h = String(dt.getHours()).padStart(2, "0");
      return Number(`${y}${m}${d}${h}`);
    },
    applyTime(t) {
      // t: yyyymmddHH
      const y = String(t).slice(0, 4);
      const m = String(t).slice(4, 6);
      const d = String(t).slice(6, 8);
      const dateStr = `${y}-${m}-${d}`;
      this.filters.time = t;
      this.filters.date = dateStr; // el-date-picker v-model 업데이트 → 달력 날짜 변경
      // URL 동기화
      const url = new URL(window.location.href);
      url.searchParams.set("time", t);
      url.searchParams.delete("unitId"); // unitId는 항상 제거
      window.history.replaceState({}, "", url);
      this.onFilterChange();
    },
    async onDateChange(val) {
      // 날짜를 06:00으로 스냅
      const date = new Date(val);
      date.setHours(6, 0, 0, 0);
      this.filters.time = this.timeNumFromDate(date);
      await this.onFilterChange();
    },
    async onFilterChange() {
      this.posts = [];

      await this.fetchContents();
      this.filters.contentId = null;
    },
    // 이전 날짜로 이동 (06:00)
    onPrev() {
      if (!this.filters.date) return;
      const d = new Date(this.filters.date);
      d.setDate(d.getDate() - 1);
      d.setHours(6, 0, 0, 0);
      const t = this.timeNumFromDate(d);
      this.applyTime(t);
    },
    // 다음 날짜로 이동 (06:00)
    onNext() {
      if (!this.filters.date) return;
      const d = new Date(this.filters.date);
      d.setDate(d.getDate() + 1);
      d.setHours(6, 0, 0, 0);
      const t = this.timeNumFromDate(d);
      this.applyTime(t);
    },
    onLatest() {
      // 항상 06:00으로 스냅하여 최신 버킷으로 이동
      const now = new Date();
      now.setHours(6, 0, 0, 0);
      const t = this.timeNumFromDate(now);
      this.applyTime(t);
    },
    // makeBucketsForDate and makeRecentBuckets removed (no longer used)
    getArtistInfo(payload) {
      this.filters.unitId = payload.unitId;
      // 유닛 선택 시 현재 선택된 날짜/시간으로 재검색
      this.onFilterChange();
    },
    async fetchContents() {
      try {
        const { data } = await this.$axios.get("/viewer/contents", {
          params: { unitId: this.filters.unitId, time: this.filters.time },
        });
        this.posts = data?.data ?? [];
      } catch (e) {
        console.error(e);
      }
    },
    openDetail(post) {
      const contentId = post.contentId != null ? post.contentId : post.id;
      const unitId = post.unitId != null ? post.unitId : this.filters.unitId;
      let url = "";
      switch (post.namespace) {
        case 700: // FanLog
          url = `/fanLog/fanLogDetail?fanLogId=${contentId}`;
          break;
        case 300: // Radar
          url = `/radars/radarContentDetail?unitId=${unitId}&contentId=${contentId}`;
          break;
        case 100: // Collection
          url = `/collection/collectionDetail?collectionId=${contentId}`;
          break;
        default:
          url = `/radars/radarContentDetail?unitId=${unitId}&contentId=${contentId}`;
      }
      window.open(url, "_blank");
    },
    async deletePost(post) {
      try {
        const id = post.id;
        if (!id) return;
        await this.$axios.delete(`/viewer/${id}`);
        this.posts = this.posts.filter((p) => p.id !== id);
      } catch (e) {
        console.error(e);
      }
    },
    getSourceLabel(post) {
      switch (post.namespace) {
        case 100:
          return "갤러리";
        case 300:
          switch (post.siteId) {
            case 3:
              return "네이버뉴스";
            case 53:
              return "트위터";
            case 6:
              return "유튜브";
            default:
              return "트렌드(미분류)";
          }
        case 700:
          return "팬로그";
        default:
          return "콘텐츠";
      }
    },
    openComments(post) {
      const contentId = post.id;
      if (!contentId) return;
      this.commentsForContentId = contentId;
      this.commentsVisible = true;
      this.loadComments(contentId);
    },
    async loadComments(contentId) {
      try {
        this.commentsLoading = true;
        this.comments = [];
        const { data } = await this.$axios.get(`/viewer/contents/${contentId}/comments?type=0`);
        this.comments = data?.data ?? [];
      } catch (e) {
        console.error(e);
      } finally {
        this.commentsLoading = false;
      }
    },
    openUser(userId) {
      if (!userId) return;
      const url = `/user/userDetail?userId=${userId}`;
      window.open(url, "_blank");
    },
    async toggleComment(c) {
      try {
        if (!c?.id) return;
        await this.$axios.put(`/viewer/contents/${this.commentsForContentId}/comments/${c.id}/toggle?type=0`);
        c.state = c.state === 1 ? 0 : 1;
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>
